import React from 'react';
import LoginForm from '../components/forms/Login';
import { useAuthStore } from '../state/auth';
import { Navigate } from 'react-router-dom';

const Login: React.FC = () => {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center px-4 py-12">
      <LoginForm />
    </div>
  );
};

export default Login;
